/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import axios from 'axios';
import { Dispatch } from 'react';
import { NetworkContext } from '../types/network';
import { clearClientToken } from './auth';

const logout = async (_?: Dispatch<any>, ctx?: NetworkContext) => {
  if (typeof window !== 'undefined') {
    await axios.post('/api/logout');
    window.location.reload();
  } else {
    await clearClientToken(ctx);
  }
};

export default logout;
